/**
 * > When using the esBuild API, all `process.env.NODE_ENV` expressions
 * > are automatically defined to `"production"` if all minification
 * > options are enabled and `"development"` otherwise. This only happens
 * > if `process`, `process.env`, and `process.env.NODE_ENV` are not already
 * > defined. This substitution is necessary to avoid code crashing instantly
 * > (since `process` is a Node API, not a web API).
 * > — https://esbuild.github.io/api/#platform
 */

// eslint-disable-next-line node/prefer-global/process
const NODE_ENV = process.env.NODE_ENV
const IS_TOUCH = window.matchMedia('(any-pointer:coarse)').matches
const IS_SM = window.matchMedia('(max-width: 700px)').matches
const IS_MD = window.matchMedia('(max-width: 1000px)').matches
const IS_LG = window.matchMedia('(max-width: 1200px)').matches

// Main environment variables
const ENV = Object.freeze({
  // Node environment
  NAME: NODE_ENV,
  IS_PROD: NODE_ENV === 'production',
  IS_DEV: NODE_ENV === 'development',

  // Device
  IS_TOUCH,
  IS_SM,
  IS_MD,
  IS_LG,
  IS_DESKTOP: window.matchMedia('(min-width: 1200px)').matches
})

// Main CSS classes used within the project
const CSS_CLASS = Object.freeze({
  LOADING: 'is-loading',
  LOADED: 'is-loaded',
  READY: 'is-ready',
  TOUCH: 'is-touch',
  LAZY_CONTAINER: 'c-lazy',
  LAZY_LOADED: '-lazy-loaded'
  // ...
})

export {
  CSS_CLASS,
  ENV
}
